var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-header'),_c('v-main',[_c('v-container',{class:_vm.isFluid ? 'py-0' : ''},[_c('router-view')],1),_c('confirm-alert'),_c('loader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }